import React from 'react';
import Icon from '../../../components/AppIcon';

const CareerStrengthsCard = ({ strengths }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
          <Icon name="TrendingUp" size={20} className="text-success" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-text-primary">Career Strengths</h3>
          <p className="text-sm text-text-secondary">Your top professional capabilities</p>
        </div>
      </div>
      <div className="space-y-4">
        {strengths?.map((strength, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-2 h-2 bg-success rounded-full mt-2 flex-shrink-0"></div>
            <div className="flex-1">
              <h4 className="font-medium text-text-primary mb-1">{strength?.title}</h4>
              <p className="text-sm text-text-secondary mb-2">{strength?.description}</p>
              <div className="flex items-center space-x-2">
                <div className="flex-1 bg-muted rounded-full h-2">
                  <div 
                    className="bg-success h-2 rounded-full spring-transition"
                    style={{ width: `${strength?.score}%` }}
                  ></div>
                </div>
                <span className="text-sm font-medium text-success">{strength?.score}%</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CareerStrengthsCard;